export default __webpack_public_path__ + "static/media/Photography-department.40a04af5.jpg";